import { BaseApiService } from './base.service';
import type { StoreCatalogResponse } from '@/types/store';

/**
 * Post-pivot storefront (GET /v1/store) — the Facade Pack product line:
 * pack and Builder Pass card. Composition and ALL display copy are
 * server-driven; `price`/`currency` are USD reference values (WEB has no
 * purchases and only displays them — mobile clients fetch live store prices).
 *
 * `projectId` scopes the catalog to a building: the pack item gains
 * `project_state` reflecting whether that building already holds an active pack.
 */
export class StoreService extends BaseApiService {
  async getCatalog(projectId?: string): Promise<StoreCatalogResponse> {
    const query = projectId
      ? `?project_id=${encodeURIComponent(projectId)}`
      : '';
    return this.httpGet<StoreCatalogResponse>(`/v1/store${query}`);
  }
}

export const storeService = new StoreService();
